import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import ApiService from '../../../../services/api'
import queryString from 'query-string';
import TableModal from '@/components/TableModal';
import { useLoanProducts, useMembers, useProspectMembers } from '@/hooks/useApi';
import SavingModal from '@/components/SavingModal';
import { tableColumnsMember,renderActionMember } from './columns'
import { formatRupiah } from '@/helpers/utils';
import { NumericFormat } from 'react-number-format';

const LoanApplication = () => {
  const params = queryString.parse(window.location.search);
  const id = params.id || null
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMember, setIsOpenMember] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [dataLoans, setDataLoans] = useState(null);
  const [formData, setFormData] = useState({
    application_notes: '',
    approval_notes: '',
    collateral_details: '',
    guarantor_address: '',
    guarantor_name: '',
    guarantor_phone: '',
    loan_product_id: null,
    member_id: null,
    principal_amount: 0,
    purpose: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    term_months: 0,
  })
  const [formDataMember, setFormDataMember] = useState({
    full_name: '',
    phone_number: '',
    occupation: '',
    email: '',
    birth_date: '',
    gender: '',
    address: '',
    codepost: '',
    no_id: '',
    npwp: '',
    cooperative_id: '',
    user_id: '', // This will need to be handled differently in practice
    photo_ktp: null,
    id_file: null,
    selfie_file: null,
    signature_file: null
  });

  const { data: membersData } = useMembers();
  const members = membersData?.data || [];

  const { data: prospectMembers } = useProspectMembers();
  const prosMember = prospectMembers?.data || [];
  const loansParams = useMemo(() => ({
    search: searchTerm,
    status: 'active',
    limit: 10,
    paginate: true
  }), [searchTerm]);
  
  const { data: resLoan,  error, refetch } = useLoanProducts(loansParams);

  const loans = resLoan?.data || [];

  useEffect(() => {
    if (id) {
      fetchMemberDetail();
    }
    setLoading(false);
  }, [id]);
  
  useEffect(() => {
    if(formData.loan_product_id) {
      fetchLoansById(formData.loan_product_id)
    }
  }, [formData.loan_product_id])
    
  const calculatePercentage = (amount) => {
    return amount * 100 + '%'
  }
    
  const fetchLoansById = async (id) => {
    try {
      const res = await ApiService.getLoanProductsById(id)
      setDataLoans(res?.data || {})
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed to load data loans'
      });
    }
  }

  const fetchMemberDetail = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/members/${id}`);
      setMember(response.data);
      setFormDataMember(response.data);
    } catch (error) {
      console.error('Error fetching member detail:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed to load member details'
      });
    } finally {
      setLoading(false);
    }
  };
  
  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: files ? files[0] : value, 
    }));
  };

  const handleResetForm = () => {
    setFormData({
      application_notes: '',
      approval_notes: '',
      collateral_details: '',
      guarantor_address: '',
      guarantor_name: '',
      guarantor_phone: '',
      loan_product_id: '',
      member_id: '',
      principal_amount: 0,
      purpose: '',
      term_months: 0,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        ...formData,
        member_id: id,
      };

      dataToSend.loan_product_id = Number(dataToSend.loan_product_id);
      dataToSend.principal_amount = Number(dataToSend.principal_amount);
      dataToSend.term_months = Number(dataToSend.term_months);
      dataToSend.member_id = Number(dataToSend.member_id);
      
      const response = await ApiService.post(`/loans/admin/apply-member`, dataToSend);
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Pengajuan Pinjaman success'
        }).then(() => {
          handleResetForm()
          navigate('/admin/loan-application')
        });
      } else {
        throw new Error(response.message || 'Pengajuan Pinjaman Failed!');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error || 'Pengajuan Pinjaman Failed!'
      });
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <span className="ml-2 text-gray-600">Loading member details...</span>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Breadcrumb */}
      <nav className="flex mb-6" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-3">
          <li className="inline-flex items-center">
            <Link 
              to="/dashboard"
              className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
            >
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
              Dashboard
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
              </svg>
              <button
                onClick={() => navigate('/admin/deposit-principal-savings')}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
              >
                Pengajuan Pinjaman
              </button>
            </div>
          </li>
          {member && (
            <li aria-current="page">
                <div className="flex items-center">
                    <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                    </svg>
                    <span className="ml-1 text-sm font-medium text-gray-500 md:ml-2 truncate max-w-xs">
                        {member.full_name}
                    </span>
                </div>
            </li>
          )}
        </ol>
      </nav>

      {/* Header */}
      <div className="rounded-lg shadow-sm p-8 mb-6">
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6">
          <div className="flex-1">
            <div className="flex items-start space-x-6">

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-4 mb-3">
                  <h1 className="text-3xl font-bold text-gray-900 truncate">
                    Pengajuan Pinjaman 
                  </h1>
                </div>
                
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row xl:flex-col gap-3 xl:w-48">
            <button 
              onClick={() => setIsOpenMember(true)}
              type='button'
              className="inline-flex items-center justify-center px-4 py-3 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              <i className='mgc_book_line mr-3'></i>
              Data Anggota
            </button>
          </div>
        </div>
      </div>
      
      <form onSubmit={handleFormSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-6">
        <div className='flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6 mt-3'>
          <div className='flex-1'>
            <div>
              <label htmlFor="loan_product_id" className="block text-sm font-medium text-gray-700">Jenis Pinjaman</label>
              <select
                id="loan_product_id"
                name="loan_product_id"
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={formData.loan_product_id}
                onChange={handleChange}
              >
                <option value="">Pilih Jenis Pinjaman</option>
                {loans?.map((res) => (
                  <option key={res.id} value={res.id}>
                      {res.name}
                  </option>
                ))}
              </select>
              <div className="overflow-x-auto">
                <table className="min-w-full border rounded-md divide-gray-200">
                  <tbody className="bg-white divide-gray-200">
                    <tr className="hover:bg-gray-50 divide-x">
                      <td className="px-6 py-4 w-[500px]">
                        <div className=''>
                          <div className="text-sm font-medium text-gray-900">{dataLoans?.name || 'Jenis Pinjaman'} - ({dataLoans?.code || 'code'})</div>
                          <div className="text-sm text-gray-500">{dataLoans?.description}</div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div>
                          <div className="text-sm text-gray-900">Min Plafond : {formatRupiah(dataLoans?.minimum_amount)}</div>
                          <div className="text-sm text-gray-900">Max Plafond : {formatRupiah(dataLoans?.maximum_amount)}</div>
                          <div className="text-sm text-gray-900">Periode : {dataLoans?.min_term_months || '1'} - {dataLoans?.max_term_months || '12'} Bulan</div>
                          <div className="text-sm text-gray-900">Min Simpanan Member : {formatRupiah(dataLoans?.min_savings_balance)}</div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div>
                          <div className="text-sm text-gray-900">{calculatePercentage(dataLoans?.interest_rate || '0')} / { dataLoans?.interest_period === 'monthly' ? 'Bulan' : dataLoans?.interest_period === 'daily' ? 'Hari' : 'Tahun' }</div>
                        </div>
                      </td>
                    </tr>  
                  </tbody>
                </table>
              </div>
            </div>
            <div className='grid grid-cols-6 md:grid-cols-2 gap-4 my-3'>
              <div>
                <label htmlFor="principal_amount" className="block text-sm font-medium text-gray-700">Jumlah Pengajuan Pinjaman</label>
                <NumericFormat
                  name="amount"
                  id="amount"
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix="Rp "
                  allowNegative={false}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Masukkan nominal"
                  value={formData.principal_amount}
                  onValueChange={(values) => {
                    setFormData({
                      ...formData,
                      principal_amount: values.value, 
                    });
                  }}
                />
              </div>
          
              <div>
                <label htmlFor="term_months" className="block text-sm font-medium text-gray-700">Tenor / Jangka Waktu</label>
                <input
                  type="text"
                  name="term_months"
                  id="term_months"
                  value={formData.term_months}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
            </div>
          </div>
        </div>
        <hr className='my-3'/>
        <h5 className='text-lg font-bold mb-3'>Detail Data Member</h5>
        <div className='grid grid-cols-3 gap-3'>
          <div className='flex flex-col gap-3'>
            <div>
              <label htmlFor="nik" className="block text-sm font-medium text-gray-700">Nomor Induk Kependudukan (NIK)</label>
              <input
                type="text"
                name="nik"
                id="nik"
                value={formDataMember.no_id}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="full_name" className="block text-sm font-medium text-gray-700">Nama Lengkap</label>
              <input
                type="text"
                name="full_name"
                id="full_name"
                value={formDataMember.full_name}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="gender" className="block text-sm font-medium text-gray-700">Jenis Kelamin</label>
              <input
                type="text"
                name="gender"
                id="gender"
                value={formDataMember.gender}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>
          <div className='flex flex-col gap-3'>
            <div>
              <label htmlFor="phone_number" className="block text-sm font-medium text-gray-700">Nomor Hp</label>
              <input
                type="text"
                name="phone_number"
                id="phone_number"
                value={formDataMember.phone_number}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="birth_date" className="block text-sm font-medium text-gray-700">Tanggal Lahir</label>
              <input
                type="text"
                name="birth_date"
                id="birth_date"
                value={formDataMember.birth_date}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="occupation" className="block text-sm font-medium text-gray-700">occupation</label>
              <input
                type="text"
                name="occupation"
                id="occupation"
                value={formDataMember.occupation}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>
          <div className='flex flex-col gap-3'>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="text"
                name="email"
                id="email"
                value={formDataMember.email}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="address" className="block text-sm font-medium text-gray-700">Alamat</label>
              <textarea
                type="text"
                name="address"
                id="address"
                value={formDataMember.address}
                rows={3}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>
        </div>
        <hr className='my-3'/>
        <h5 className='text-lg font-bold my-3'>Detail Data Penjamin</h5>
        <div className='grid grid-cols-3 gap-3'>
          <div>
            <label htmlFor="guarantor_name" className="block text-sm font-medium text-gray-700">Nama</label>
            <input
              type="text"
              name="guarantor_name"
              id="guarantor_name"
              value={formData.guarantor_name}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="guarantor_phone" className="block text-sm font-medium text-gray-700">Nomor Hp</label>
            <input
              type="text"
              name="guarantor_phone"
              id="guarantor_phone"
              value={formData.guarantor_phone}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="guarantor_address" className="block text-sm font-medium text-gray-700">Alamat</label>
            <input
              type="text"
              name="guarantor_address"
              id="guarantor_address"
              value={formData.guarantor_address}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>
        <div className="flex items-center justify-end space-x-4 mt-8 pt-6 border-t border-gray-200">
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Submit
          </button>
        </div>
      </form>
      
      <TableModal 
        isOpen={isOpen}
        onClose={() => setIsOpen(!isOpen)}
        columns={tableColumnsMember}
        data={prosMember}
        action={renderActionMember}
        title="Data Calon Anggota"
        navigate={navigate}
      />

      <TableModal 
        isOpen={isOpenMember}
        onClose={() => setIsOpenMember(!isOpenMember)}
        columns={tableColumnsMember}
        data={members}
        action={renderActionMember}
        title="Data Anggota"
        navigate={navigate}
      />
    </div>
  );
};

export default LoanApplication;
